<script>
import mainMenu from '@/components/main-menu'
import userMenu from '@/components/user-menu'
import siteMessage from '@/components/site-message'

export default {
  name: 'app',
  data () {
    return {
      showMessagePanel: false
    }
  },
  components: {
    'main-menu': mainMenu,
    'site-message': siteMessage,
    'user-menu': userMenu
  },
  methods: {
    showMessagePanelChange (isVisible) {
      this.showMessagePanel = isVisible
    },
    isPrivate () {
      return this.$store.getters.isAuthenticated ? 1 : 0
    }
  }
}
</script>

<template>
  <div class="flex-wrapper">
    <el-container
      id="app"
      :span="24"
    >
      <el-header height="auto">
        <el-col :span="16">
          <main-menu :key="isPrivate()"></main-menu>
        </el-col>
        <el-col
          :span="8"
          align="right"
        >
          <user-menu :key="isPrivate()"></user-menu>
        </el-col>
      </el-header>
      <router-view @show-message-panel="showMessagePanelChange" class="main-page"></router-view>
    </el-container>
    <el-footer height="auto">
      <el-row :gutter="20">
        <el-col
          :span="8"
          style="text-align: right;"
        >
          <address>
            <h5>Przedsiębiorstwo Wielobranżowe <big>B&amp;K</big></h5>
            Fabryka Pomocy Szkolnych<br>
            nip 626-001-85-72<br><br>
            ul. Cyryla i Metodego 76 i 78<br>
            41-909 Bytom
          </address>
        </el-col>
        <el-col
          :span="8"
          style="text-align: left;"
        >
          <i
            class="el-icon-phone-outline"
            style="display: block-inline; float: left; font-size: 2.2rem; vertical-align: top;"
          ></i>
          +48 <big>32&nbsp;286&nbsp;7373</big><br>
          pn - pt <big>8</big>:00 - <big>15</big>:00<br>
          <i
            class="el-icon-postcard"
            style="display: block-inline; font-size: 2.2rem; margin-top: .2rem; vertical-align: sub;"
          ></i>
          info@chemik.aip.pl<br><br>

        </el-col>
        <el-col
          :span="8"
          class="message"
        >
          <div>
            <span class="inline">Zauważyłeś błąd na stronie?</span>
            <span class="inline">Masz jakieś pomysły lub uwagi?</span>
            <span class="inline">Chcesz nam zadać pytania?</span><br><br>
            <el-button
              icon="el-icon-chat-round"
              size="small"
              style="margin-top: .7rem .5em;"
              type="primary"
              @click="showMessagePanel = true"
            >Napisz do nas</el-button>
          </div>
          <div><small>B&amp;K &copy; 2019</small></div>
        </el-col>
      </el-row>
    </el-footer>
    <el-drawer
      custom-class="intouch"
      direction="rtl"
      size="50%"
      :visible.sync="showMessagePanel"
    >
      <h2 slot="title">Napisz do nas!</h2>
      <site-message @update:visible="showMessagePanelChange"></site-message>
    </el-drawer>
  </div>
</template>

<style lang="sass">
  $--container-max-width: 1400px
  /* theme color */
  $--color-primary: teal

  // icon font path, required
  $--font-path: "~element-ui/lib/theme-chalk/fonts"
  $fa-font-path: "~font-awesome/fonts"

  @import "~font-awesome/scss/font-awesome"
  @import url('https://fonts.googleapis.com/css?family=Ubuntu+Condensed:300,300i,400,400i,500,500i,700,700i|Roboto:300,300i,400,400i,700,700i&subset=latin-ext')
  // @import url('https://fonts.googleapis.com/css?family=Material+Icons')
  @import "~element-theme-chalk/src/index.scss"

  // Typesetting variables. Edit these!
  $baseFontSize: 12
  // in pixels. This would result in 22px on desktop
  $baseLineHeight: 1.3
  // how large the line height is as a multiple of font size
  $leading: $baseLineHeight * 1rem

  // Rate of growth for headings
  // I actually like this to be slightly smaller then the leading. Makes for tight headings.
  $scale: 1.1

  /* Setup */
  html, body
    color: $--color-text-regular
    font-family: Roboto, Helvetica, sans-serif
    font-size: $--font-size-base
    word-break: normal
    margin: 0
    padding: 0
    height: 100%

    // Make everything look a little nicer in webkit
    -webkit-font-smoothing: antialiased

    -webkit-text-size-adjust: auto
    -moz-text-size-adjust: auto
    -ms-text-size-adjust: auto
    -o-text-size-adjust: auto
    text-size-adjust: auto

  /* Copy & Lists */
  p
    line-height:  $leading
    word-spacing: .1rem
    margin-top: .8rem
    margin-bottom: .6rem

  ul, ol
    margin-top: $leading
    margin-bottom: $leading
    li
      line-height: $leading
    ul, ol
      margin-top: 0
      margin-bottom: 0

  ul
    &.flat
      list-style-type: none
      padding: 0
      margin: 0

  blockquote
    line-height: $leading
    margin: 0
    margin-left: .2rem
    padding-left: .6rem
    border-left: .3rem solid $--border-color-lighter

  .articles
    display: flex
    flex-flow: row wrap
    justify-content: center
    align-items: flex-start
    align-content: flex-start

    & h1
      width: 100%

    & article
      flex: 1 0 28rem
      margin: 1rem

      & .el-main
        padding: 0

  .inline
    display: inline-block

  .nowrap
    white-space: nowrap

  .clickable
    cursor: pointer

  /* Menu */
  .el-menu--horizontal

    & .el-badge
      left: -1rem
      vertical-align: sub

      & .el-badge__content
        height: 1.2rem
        font-size: .8rem
        border-radius: 1.2rem;

    & .el-menu-item, & .el-submenu
      & .el-submenu__title
        position: relative

      &:not(.is-disabled):hover
        color: $--color-primary

        & i:not(.is-disabled)
          color: inherit

      & i
        vertical-align: text-bottom

        &.el-icon-arrow-down
          position: relative
          font-size: 1rem
          left: -0.7rem
          top: 0.3rem

  /* User menu */
  .user-menu

    & .el-menu-item, & .el-submenu
      float: right
      padding: 0 .5rem

      & i
        font-size: $leading * $scale * 1.3

      & .el-submenu__title
        padding: 0

  /* Main content */
  .main-page
    padding: 3rem

  .flex-wrapper
    &::after
      content: ""
      background: url(./assets/bg.png) no-repeat top center
      opacity: 0.1
      top: 4rem
      left: 0
      /*bottom: 0*/
      right: 0
      height: 100%;
      position: fixed
      z-index: -1

  /* Headings */
  h1, h2, h3, h4, h5, h6
    font-family: 'Ubuntu Condensed', sans-serif
    color: $--color-text-regular
    margin-bottom: .3rem

  h1
    color: $--color-primary
    font-size: 2.5 * $scale * 1rem
    line-height: 2 * $leading
    font-weight: 500

  h2
    font-size: 1.7 * $scale * 1rem
    line-height: 1.6 * $leading

    & button
      vertical-align: text-top

    & button
      vertical-align: text-top

  h3
    font-size: 1.3 * $scale * 1rem
    line-height: 1.3 * $leading

  h4
    font-size: 1.2 * $scale * 1rem
    line-height: 1.2 * $leading

  h5
    font-size: 1.1 * $scale * 1rem
    line-height: 1.1 * $leading

  h6
    font-size: $scale * 1rem
    line-height: 1 * $leading

  /* Tables */
  table
    margin-top: $leading
    border-spacing: 0px
    border-collapse: collapse

    tr
      &.active
        font-weight: bold
        background-color: $--color-primary-light-9

    td, th
      padding: 0
      line-height: $baseLineHeight * $baseFontSize - 0px

  .el-table

    & tr.disabled
      opacity: .7

    & tr.selected input
      color: $--color-text-primary
      background-color: $--color-primary-light-9

    & .cell
      word-break: normal

    & .nowrap .cell
      @extend .nowrap

    &.el-table__expand-column
      vertical-align: top
      padding-top: 1.5rem

    & .expanded

      & td
        border: none


        & .name
          @extend h2

    td.el-table__expanded-cell

      & .details
        display: flex
        flex-flow: row wrap

        & .col-side
          display: flex
          flex-flow: column wrap
          justify-content: flex-start
          flex: 1

          & .display-item
            min-height: 3rem

        & .col-main
          display: flex
          flex-flow: column wrap
          flex: 2

          & .display-item

  /* Code blocks */
  code
    // Forces text to constrain to the line-height. Not ideal, but works.
    vertical-align: bottom

  /* Leading paragraph text */
  .lead
    font-size: 0.85 * $leading
    line-height: 1.2 * $leading
    word-spacing: .2rem
    padding: .5rem 0
    border-top: 1px dotted $--border-color-light
    border-bottom: 1px dotted $--border-color-light

  /* Hug the block above you */
  .hug
    margin-top: 0

  /* Steps */
  .el-step__title
    font-size: .9rem
    line-height: $leading

  .el-step__description
    font-size: .7rem
    line-height: $leading * .7
    margin-bottom: .3rem

  /* layout config */
  .flex-wrapper
    display: flex
    flex-direction: column
    justify-content: space-between
    min-height: 100%

  .el-container
    flex: 1 0 auto
    max-width: $--container-max-width
    width: 100%
    margin: 0 auto

  footer.el-footer
    border-top: 1px solid $--color-primary-light-5
    background-image: linear-gradient(to bottom, $--color-primary-light-9 80%, $--color-primary-light-7)
    color: $--color-primary
    flex-shrink: 0
    font-size: .9rem
    margin: 0
    margin-top: auto
    padding: 2.5rem

    & h5
      color: $--color-primary
      margin-top: 0

    address
      font-style: normal

    & > .el-row
      display: flex
      flex-flow: row wrap
      align-items: stretch

      & > .el-col
        flex: 1 0 18rem
        margin-bottom: 2rem

        &.message
          display: flex
          flex-direction: column
          text-align: right

          & div:first-child
            flex: 2
            margin-bottom: .5rem

  /* pagination */
  .el-pagination
    margin-top: .5rem

  /* Tiled items */
  .tiles.el-row--flex
    flex-flow: row wrap
    justify-content: space-between
    justify-content: flex-start

  .display-item
    padding: .5rem
    margin: .5rem

    & .label
      color: $--color-primary-light-3

    & .el-button + .el-button
      margin-left: .1rem

  .user-details

    & h2
      padding-bottom: .3rem
      border-bottom: $--border-base

    & .display-item
      flex: 0 0 18rem

  /* intouch */
  .intouch
    height: 100%
    display: flex
    flex-direction: column

    & .el-drawer__header
      margin-bottom: .5rem

    & .el-drawer__body
      flex: 2

      & .el-main
        display: flex
        flex-direction: column
        height: 100%
        margin: 1.5rem
        padding: 0

        & .message-form
          padding: 0 .5rem

        & .messages-wrapper
          display: flex
          flex: 2
          flex-direction: column
          overflow: auto
          margin-bottom: 3rem

          & .messages
            position: absolute

          & .expanded

            & .teaser
              display: none

          & .el-table__expand-column
            padding-top: 1.5rem

          & .el-table__expanded-cell
            padding: 0 1rem 2rem 2rem

          & .cell
            margin-right: .3rem

            & h3
              margin: .8rem 0

            & .annotation
              float: right
              font-size: .8rem

            & .teaser
              font-size: .9rem
              line-height: 1.2rem

</style>



// WEBPACK FOOTER //
// src/app.vue